import { useIntl } from 'react-intl';

import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';

export const useSectionName = (appId?: EvidencePlatformSidebarAppID) => {
  const { formatMessage } = useIntl();

  switch (appId) {
    case EvidencePlatformSidebarAppID.dataAdministration:
      return formatMessage({ id: 'sidebar.sectionTitle.dataAdmin' });
    case EvidencePlatformSidebarAppID.projects:
    case EvidencePlatformSidebarAppID.conceptGroups:
      return formatMessage({ id: 'sidebar.sectionTitle.projects' });
    case EvidencePlatformSidebarAppID.users:
    case EvidencePlatformSidebarAppID.organizations:
      return formatMessage({ id: 'sidebar.sectionTitle.sysAdmin' });
    case EvidencePlatformSidebarAppID.extractionAccuracy:
      return formatMessage({ id: 'sidebar.sectionTitle.extractionAccuracy' });
    default:
      return '';
  }
};
